export const NUMERO_APOSTA_CHANGED = 'NUMERO_APOSTA_CHANGED'
export const NUMERO_APOSTA_CLEAR = 'NUMERO_APOSTA_CLEAR'
export const NUMERO_APOSTA_CLEAR_ALL = 'NUMERO_APOSTA_CLEAR_ALL'
export const NUMERO_APOSTA_ADD = 'NUMERO_APOSTA_ADD'

export const changeNumerpAposta = payload => ({
    type: NUMERO_APOSTA_CHANGED,
    payload: payload
})

export const changeNumerpApostaClear = () => ({
    type: NUMERO_APOSTA_CLEAR,
    payload: ''
})

export const addNumeroAposta = payload => ({
    type: NUMERO_APOSTA_ADD,
    payload: payload
})

export const changeNumeroApostaClearAll = () => ({
    type: NUMERO_APOSTA_CLEAR_ALL,
    payload: []
})



// WEBPACK FOOTER //
// ./src/reducers/modalidade/modalidadeInputAction.js